import { ViewTemplate } from '../ViewTemplate';
import { WorkgroupsTable } from './WorkgroupsTable';
import { useGetSurveyWorkgroupsQuery } from '@api/workgroups';
import { SurveyDelegationProps } from '../types';
import { DelegateWorkgroupBtn } from './DelegateWorkgroupBtn';
import { useAppSelector } from '@reducers/index';
import { getRootConfig } from '@selectors/globalData';
import { FeaturePermissions } from '@services/permissions/FeaturePermissions';
import { UpgradeRequired } from '@routes/upgrade-required';

interface Props extends Pick<SurveyDelegationProps, 'view' | 'onChangeView' | 'survey' | 'metricGroups' | 'utrvIds'> {}

export const WorkgroupsView = ({ view, onChangeView, survey, metricGroups, utrvIds }: Props) => {
  const rootConfig = useAppSelector(getRootConfig);
  const workgroupsLimit = FeaturePermissions.getLimitWorkgroups(rootConfig);
  const { data: workgroups = [] } = useGetSurveyWorkgroupsQuery(survey._id, { skip: workgroupsLimit === 0 });

  if (workgroupsLimit === 0) {
    return <UpgradeRequired />;
  }

  return (
    <ViewTemplate
      view={view}
      onChangeView={onChangeView}
      actionBtns={<DelegateWorkgroupBtn survey={survey} metricGroups={metricGroups} delegatedWorkgroups={workgroups} />}
    >
      <WorkgroupsTable workgroups={workgroups} survey={survey} metricGroups={metricGroups} utrvIds={utrvIds} />
    </ViewTemplate>
  );
};
